var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.651441 0C1.01122 0 1.30288 0.29166 1.30288 0.651441V11.5255H15.1836C15.5434 11.5255 15.835 11.8171 15.835 12.1769C15.835 12.5367 15.5434 12.8284 15.1836 12.8284H0.651441C0.29166 12.8284 0 12.5367 0 12.1769V0.651441C0 0.29166 0.29166 0 0.651441 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0682 2.13423C13.356 2.3501 13.4143 2.75843 13.1984 3.04625L9.81596 7.55622C9.69293 7.72026 9.49985 7.8168 9.29481 7.8168C9.08976 7.8168 8.89668 7.72026 8.77365 7.55622L7.41565 5.74555L4.17849 10.0618C3.96262 10.3496 3.5543 10.4079 3.26647 10.1921C2.97865 9.97619 2.92032 9.56786 3.13619 9.28004L6.8945 4.26895C7.01752 4.10492 7.2106 4.00838 7.41565 4.00838C7.6207 4.00838 7.81378 4.10492 7.9368 4.26895L9.29481 6.07963L12.1561 2.26452C12.372 1.9767 12.7803 1.91836 13.0682 2.13423Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeChartIcon);
export default __webpack_public_path__ + "static/media/time-chart-icon.bf65c2c8d16b3be0ebbb177fae4488c3.svg";
export { ForwardRef as ReactComponent };